

$(document).ready(function () {

    let dropdown = $('.dropdown-button');
    let toogle_menu_bar = $('#toogle-menu-bar');
    let button_toogle_menu_bar = $('#button_toogle_menu_bar');
    let toogle_page_filter = $('#toogle-page-filter');
    let button_toogle_page_filter = $('#button_toogle_page_filter');
    let button_page_filter = $('#button_page_filter');

    let actives = () => new Promise((resolve, reject) => {
        let dropdown = $('.dropdown-button');
        dropdown.map( (index,elements) => {
            if(elements.classList.contains('active')){
                elements.classList.remove('active');
            }
        });
        resolve(true);
    })

    dropdown.map( (index,elements) => {
        $(elements).on('click', function (e) {
            if(elements.classList.contains('active')){
                e.target.classList.remove('active');
            }else{
                actives().then(
                    result => {
                        e.target.classList.add('active');
                    }
                );
            }

        })
    })

    button_toogle_menu_bar.on('click', function (e) {
        toogle_menu_bar[0].classList.toggle('show');
    })

    button_toogle_page_filter.on('click', function (e) {
        toogle_page_filter[0].classList.toggle('show');
        $('#filters-grande')[0].classList.toggle('d-none');
    })

    button_page_filter.on('click', function (e) {
        toogle_page_filter[0].classList.toggle('show');
        $('#filters-grande')[0].classList.toggle('d-none');
    })

})